import { useCycleStore } from '@cycle-hangars/store/store';
import { ConfirmationTemplate } from '@templates';
import { useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { RoutesList } from '@cycle-hangars/routes/Routes';
import { basename } from '../../../routes/basename';
import { FormTitle } from '@molecules/*';
import { Link } from '@atoms/*';

export const Confirmation = () => {
  const {
    caseReferenceId,
    receiveConfirmationEmail,
    resetIssueDetails,
    resetYourDetails,
    email,
  } = useCycleStore();

  const location = useLocation();

  const [tempEmail, setTempEmail] = useState('');

  useEffect(() => {
    if (tempEmail === '') {
      setTempEmail(email);
    }
    // push 10 states to history to prevent user from going back to previous pages
    for (let i = 0; i < 10; i++) {
      window.history.pushState(
        { page: i },
        '',
        basename + RoutesList.CONFIRMATION,
      );
    }
  }, []);

  useEffect(() => {
    const handlePopState = () => {
      // Prevent default behavior and navigate to home page
      window.location.replace('https://www.westminster.gov.uk/report-it');
    };

    window.addEventListener('popstate', handlePopState);
    resetIssueDetails();
    resetYourDetails();

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  const confirmationTitle = 'Your report has been submitted';
  const contentTitle = `What happens next?`;
  const contentSubtext = (
    <div className="text-bodyXl text-text-body mb-5 flex flex-col gap-6">
      {receiveConfirmationEmail === 'Yes' ? (
        <p>We have sent a confirmation email to {tempEmail}.</p>
      ) : null}
      <p>
        We aim to review your issue <strong>within 2 working days</strong>{' '}
        (Monday to Friday, excluding Bank Holidays).
      </p>
    </div>
  );

  const contactTitle = `Who to contact`;
  const getContactEmail = 'cycleparking@westminster.gov.uk';

  const contactSubtext = (
    <div className="text-bodyXl text-text-body flex flex-col gap-6">
      <p>
        If you’d like an update on your report contact: {''}
        <Link
          className="inline font-normal"
          href={`mailto:${getContactEmail}`}
          linkType="inline"
          title="Email to westminster cycle parking team"
          external={true}
        >
          {getContactEmail}
        </Link>
      </p>
    </div>
  );

  const navigationButton = {
    label: 'Return to homepage',
    isExternalLink: true,
    href: 'https://www.westminster.gov.uk/report-it ',
  };

  const content = (
    <>
      <FormTitle text={contentTitle} subtext={contentSubtext} />
      <FormTitle text={contactTitle} subtext={contactSubtext} />
    </>
  );

  return (
    <ConfirmationTemplate
      reference={caseReferenceId}
      content={content}
      button={navigationButton}
      confirmationTitle={confirmationTitle}
      feedbackLink={true}
    />
  );
};
